<template lang="pug">
  .newWishPopup
    form.newWishPopup__content(@submit.prevent="submit")
      .newWishPopup__closer(@click="$emit('close')")
      textarea(v-model="message" placeholder="Напишите ваше пожелание до 296 символов с пробелами")
      .newWishPopup__bottom
        .newWishPopup__recaptcha(ref="newWishPopup__recaptcha")
        button.app-button(type="submit" :class="{disabled: !captchaSuccess}") Отправить
</template>

<script>
export default {
  name: "NewWishPopup",

  data: ()=>({
    message: '',
    captchaSuccess: false,
  }),

  mounted() {
    const self = this;
    grecaptcha.render(this.$refs.newWishPopup__recaptcha, {
      'sitekey' : '6LewTwcaAAAAAEjGz4mD6tA7sCva1i8jevV5y3Wr',
      callback(){
        self.captchaSuccess = true;
      }
    });
  },

  methods: {
    async submit() {
      if (grecaptcha.getResponse()) {
        try {
          const response = await this.axios.post('', {
            USER_MESSAGE: this.message,
            ACTION: 'addGreetingNewyear'
          });
          if (response.data.STATUS === 'ok') {
            this.$emit('showTreeLight')
            this.$emit('close');
          }

        } catch (e) {
          console.log(e);
        }
      }
    }
  },
  beforeMount() {
    this.$store.commit('pageHidden')
  },
  beforeDestroy() {
    this.$store.commit('pageDelHidden')
  }
}
</script>

<style scoped lang="scss">
.newWishPopup {
  position: fixed;
  z-index: 10000;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(#000, 0.5);

  &__content {
    position: relative;
    width: 65.2rem;
    max-width: 92%;
    padding: 5.5rem 5.5rem 2.9rem;
    //border: 0.25rem solid #fff;
    border-radius: 2rem;
    //box-shadow: 0 0 0.5rem #fff;
    backdrop-filter: blur(1.2rem);
    background: url(../assets/img/popup_border.png) no-repeat center center / 100% 100%;
    box-shadow: 0 0 to_rem(32px) 0px rgba(#8ceffe, 0.2);
    @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
      background-color: rgba(#000, 0.6);
    }
    @media screen and (min-width: 0 \0) and (min-resolution: .001dpcm) {
      background-color: rgba(#000, 0.6);
    }
  }

  &__closer {
    position: absolute;
    top: 2.6rem;
    right: 3.25rem;
    width: 2.5rem;
    height: 2.5rem;
    cursor: pointer;

    &:before, &:after {
      content: '';
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      width: 100%;
      height: 0.25rem;
      border-radius: 1rem;
      background: #fff;
    }

    &:before {
      transform: translate(-50%, -50%) rotate(45deg);
    }

    &:after {
      transform: translate(-50%, -50%) rotate(-45deg);
    }
  }

  textarea {
    overflow: hidden;
    resize: none;
    width: 100%;
    height: 27.6rem;
    margin-bottom: 2rem;
    padding: 2.4rem 2.6rem;
    border: 0.25rem solid #fff;
    border-radius: 2rem;
    background: transparent;
    font-size: 1.5rem;
    line-height: 1.22;
    color: #fff;
  }

  &__bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;

  }
  .app-button {
    padding: 0.8rem 4.8rem;
  }

  @include mobile_or_P {
    overflow: auto;
    overflow-x: hidden;
    @include landscape {
      align-items: flex-start;
      padding: 5rem 0;
    }
    &__content {
      width: 100vmin;
      padding: 4rem 1.9rem 3.6rem;
      background-image: url(../assets/img/popup_border-mobile.png);
    }

    &__closer {
      top: 1.5rem;
      right: 2rem;
      width: 2rem;
      height: 2rem;
    }

    textarea {
      height: 45vmax;
      margin-bottom: 1.3rem;
      padding: 1.8rem 1.6rem;
      font-size: 1.25rem;
    }

    &__bottom {
      flex-direction: column;
      justify-content: flex-start;
    }

    &__recaptcha {
      transform: scale(0.86);
    }

    .app-button {
      margin-top: 1.7rem;
    }
    @include razr440 {
      textarea {
        margin-bottom: 0.5rem;
      }
      &__recaptcha {
        transform: scale(0.7);
      }
      .app-button {
        margin-top: 1rem;
      }
    }
    @include razr360 {
      &__content {
        padding: 5rem 1.9rem 2.6rem;
      }
      textarea {
        margin-bottom: 0.2rem;
      }
      &__recaptcha {
        transform: scale(0.6);
      }
      .app-button {
        margin-top: 0.2rem;
      }
    }
  }
}
</style>